import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const SkeletonContext = createContext(false);
export function SkeletonContextProvider({ loading, children }) {
    return _jsx(SkeletonContext.Provider, { value: loading, children: children });
}
